// extracted by mini-css-extract-plugin
export var active = "MotherMenu-module--active--7a425";
export var capitalize = "MotherMenu-module--capitalize--77fb6";
export var fs14 = "MotherMenu-module--fs-14--aba95";
export var fs16 = "MotherMenu-module--fs-16--05336";
export var fs20 = "MotherMenu-module--fs-20--6aff1";
export var fs24 = "MotherMenu-module--fs-24--df3c8";
export var fs32 = "MotherMenu-module--fs-32--e2ae6";
export var fs40 = "MotherMenu-module--fs-40--fdbfb";
export var fsItalic = "MotherMenu-module--fs-italic--40823";
export var fsLg = "MotherMenu-module--fs-lg--9502b";
export var fsMd = "MotherMenu-module--fs-md--b125c";
export var fsNormal = "MotherMenu-module--fs-normal--2790e";
export var fsSm = "MotherMenu-module--fs-sm--5149c";
export var fsXl = "MotherMenu-module--fs-xl--056e0";
export var fsXs = "MotherMenu-module--fs-xs--04b46";
export var fsXxl = "MotherMenu-module--fs-xxl--c7bbf";
export var fsXxs = "MotherMenu-module--fs-xxs--09638";
export var fwBold = "MotherMenu-module--fw-bold--1cd1c";
export var fwMedium = "MotherMenu-module--fw-medium--222bc";
export var fwNormal = "MotherMenu-module--fw-normal--14f78";
export var gotham_bold = "MotherMenu-module--gotham_bold--15c28";
export var gotham_bold_italic = "MotherMenu-module--gotham_bold_italic--5661f";
export var gotham_book = "MotherMenu-module--gotham_book--af473";
export var gotham_book_italic = "MotherMenu-module--gotham_book_italic--9ba3a";
export var grid = "MotherMenu-module--grid--4f104";
export var icons = "MotherMenu-module--icons--67267";
export var iconsList = "MotherMenu-module--iconsList--c1ec2";
export var lowercase = "MotherMenu-module--lowercase--a55a2";
export var menu = "MotherMenu-module--menu--f80dd";
export var mothermenu = "MotherMenu-module--mothermenu--fc41d";
export var sitesButton = "MotherMenu-module--sitesButton--4632d";
export var sitesList = "MotherMenu-module--sitesList--873c6";
export var text = "MotherMenu-module--text--08aea";
export var toggleSwitchButton = "MotherMenu-module--toggleSwitchButton--b3d74";
export var toggleSwitchButtons = "MotherMenu-module--toggleSwitchButtons--09db7";
export var uppercase = "MotherMenu-module--uppercase--eb7dd";